import get from 'lodash/get';

import BaseIvrNode, { EMPTY_ERROR_ID_MESSAGE } from './baseIvrNode';

import { HttpNodeVariable } from './helpers/HttpNodeVariable';
import { IsNotEmpty, IsNumber, IsOptional, IsString, Validate, ValidateIf, ValidateNested } from 'class-validator';
import { IsUrlOrUrlTemplateValid } from 'src/actions/ivrs/validators/isUrlOrUrlTemplateValidator';
import { Type } from 'class-transformer';

export enum HTTP_METHOD {
  POST = 'POST',
  GET = 'GET',
}

enum DataDipAuthType {
  BASIC = 'Basic',
}

export default class DataDipNode extends BaseIvrNode {
  @Validate(IsUrlOrUrlTemplateValid)
  url: string;

  @IsString()
  method: HTTP_METHOD;

  @IsNumber()
  @IsOptional()
  timeout: number;

  @ValidateIf(props => get(props, 'method') === HTTP_METHOD.POST)
  @IsString()
  contentType?: string;

  @ValidateIf(props => get(props, 'method') === HTTP_METHOD.POST)
  body?: string;

  @ValidateNested({ each: true })
  @Type(() => DataDipAuth)
  auth: DataDipAuth;

  @ValidateNested({ each: true })
  @Type(() => HttpNodeVariable)
  variables: HttpNodeVariable[];

  @IsString()
  @IsNotEmpty({ message: 'Please select the default next node the customer will go to' })
  nextId: string;

  @IsString()
  @IsNotEmpty({ message: EMPTY_ERROR_ID_MESSAGE })
  errorNodeId: string;
}

class DataDipAuth {
  @IsString()
  @IsOptional({ message: 'Please enter a valid Credential ID' })
  type?: DataDipAuthType;

  @ValidateIf(props => get(props, 'type') === DataDipAuthType.BASIC)
  @IsNotEmpty()
  credentialId?: string;
}
